import { Button, Spin } from 'antd';
import { cloneDeep } from 'lodash';
import React, { memo, useMemo, useState } from 'react';
import { MODULE_TYPES } from '../../../../common/constants';
import { modalContext } from '../../../../components/AppComponentContainer';
import ArticleCarousel from '../../../component/articleModules/ArticleCarousel';
import ArticleCarouselV2 from '../../../component/articleModules/ArticleCarouselV2';
import ArticleList from '../../../component/articleModules/ArticleList';
import ArticleListV2 from '../../../component/articleModules/ArticleListV2';
import FeatureArticleCard from '../../../component/articleModules/FeatureArticleCard';
import FeaturedArticleCardV2 from '../../../component/articleModules/FeaturedArticleCardV2';
import ModuleCard from '../../../component/card/ModuleCard';
import CategoryCard from '../../../component/categoryModule/CategoryCard';
import TopicCarousel from '../../../component/categoryModule/CategoryCarousel';
import TopicGrid from '../../../component/categoryModule/CategoryGrid';
import TopicList from '../../../component/categoryModule/CategoryList';
import CollectionCarousel from '../../../component/collectionModule/CollectionCarousel';
import CollectionGrid from '../../../component/collectionModule/CollectionGrid';
import CollectionList from '../../../component/collectionModule/CollectionList';
import ContributorCarousel from '../../../component/contributorModules/ContributorCarousel';
import ContributorGrid from '../../../component/contributorModules/ContributorGrid';
import ContributorList from '../../../component/contributorModules/ContributorList';
import BannerImage from '../../../component/ctaModule/BannerImage';
import CtaButtonList from '../../../component/ctaModule/CtaButtonList';
import CtaCard from '../../../component/ctaModule/CtaCard';
import CtaCarousel from '../../../component/ctaModule/CtaCarousel';
import CtaGrid from '../../../component/ctaModule/CtaGrid';
import FeaturedCollection from '../../../component/featuredModules/FeaturedCollection';
import FeaturedCollectionCarousel from '../../../component/featuredModules/FeaturedCollectionCarousel';
import FeaturedContributor from '../../../component/featuredModules/FeaturedContributor';
import FeaturedPodcastCarousel from '../../../component/featuredModules/FeaturedPodcastCarousel';
import FeaturedCarousel from '../../../component/featuredModules/FeaturedVideoCarousel';
import FormCarousel from '../../../component/formModules/FormCarousel';
import FormDisplay from '../../../component/formModules/FormDisplay';
import TemplateLayout from '../../../component/layout/TemplateLayout';
import Contact from '../../../component/marketingComponent/contact/Contact';
import CtaBanner from '../../../component/marketingComponent/ctaModule/CtaBanner';
import Donate from '../../../component/marketingComponent/donate/Donate';
import FaqModule from '../../../component/marketingComponent/faqModule/FaqModule';
import HeavyModule from '../../../component/marketingComponent/heavyModule/HeavyModule';
import HeroBlock from '../../../component/marketingComponent/heroModules/HeroBlock';
import InformationBlock from '../../../component/marketingComponent/informationModule/InformationBlock';
import NewsLetter from '../../../component/marketingComponent/newsLatter/NewsLetter';
import QuoteSlider from '../../../component/marketingComponent/quoteModule/QuoteSlider';
import PodcastCarousel from '../../../component/podcastModule/PodcastCarousel';
import PodcastGrid from '../../../component/podcastModule/PodcastGrid';
import PodcastInfo from '../../../component/podcastModule/PodcastInfo';
import PodcastList from '../../../component/podcastModule/PodcastList';
import SectionAdd from '../../../component/sectionWrapper/SectionAdd';
import SectionWrapper from '../../../component/sectionWrapper/SectionWrapper';
import TagCarousel from '../../../component/tagModules/TagCarousel';
import TagGrid from '../../../component/tagModules/TagGrid';
import TagHero from '../../../component/tagModules/TagHero';
import VideoCarousel from '../../../component/videoModule/VideoCarousel';
import VideoGrid from '../../../component/videoModule/VideoGrid';
import VideoInfo from '../../../component/videoModule/VideoInfo';
import VideoInfoV2 from '../../../component/videoModule/VideoInfoV2';
import VideoList from '../../../component/videoModule/VideoList';
import { FORM_TYPES, useEditPage } from '../../context/EditPageProvider';
import { usePagePreview } from '../../context/PreviewPageProvider';

const SettingButton = () => {
  const { setSelectionType, isAdding } = useEditPage();

  const handleClick = () => {
    if (isAdding) return;
    setSelectionType(MODULE_TYPES.SETTINGS);
  };

  return (
    <div className="section-add-wrapper">
      <div className="section-add-block">
        <Button disabled={isAdding} onClick={handleClick} type="text">
          <svg
            width="31"
            height="31"
            viewBox="0 0 31 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.7559 2.58301C14.4408 2.58301 14.1693 2.81159 14.1177 3.12288L13.7519 5.32528C13.1232 5.43335 12.5153 5.60044 11.9304 5.81722L10.5076 4.09163C10.3074 3.84751 9.95897 3.78391 9.68514 3.94279L8.39852 4.68701C8.12469 4.8446 8.00488 5.1771 8.11597 5.4716L8.89803 7.56047C8.4131 7.9646 7.96509 8.41261 7.56095 8.89754L5.47209 8.11548C5.17759 8.0044 4.84508 8.1242 4.6875 8.39803L3.94328 9.68465C3.7844 9.95849 3.848 10.3069 4.09212 10.5071L5.81771 11.9299C5.60093 12.5149 5.43384 13.1227 5.32577 13.7514L3.12337 14.1172C2.81208 14.1701 2.5835 14.439 2.5835 14.7555V16.2439C2.5835 16.5591 2.81208 16.8305 3.12337 16.8822L5.32577 17.248C5.43384 17.8767 5.60093 18.4845 5.81771 19.0694L4.09212 20.4923C3.848 20.6925 3.78569 21.0409 3.94328 21.3147L4.6875 22.6013C4.84508 22.8752 5.17759 22.995 5.47209 22.8839L7.56095 22.1018C7.96509 22.5867 8.4131 23.0347 8.89803 23.4389L8.11597 25.5278C8.00488 25.8235 8.12598 26.1548 8.39852 26.3123L9.68514 27.0566C9.95897 27.2141 10.3074 27.1505 10.5076 26.9077L11.9279 25.1821C12.5135 25.3993 13.1224 25.5659 13.7519 25.6741L14.1177 27.8765C14.1706 28.1878 14.4395 28.4163 14.7559 28.4163H16.2444C16.5596 28.4163 16.831 28.1878 16.8826 27.8765L17.2485 25.6741C17.8772 25.566 18.485 25.3989 19.0699 25.1821L20.4928 26.9077C20.693 27.1518 21.0414 27.2141 21.3152 27.0566L22.6018 26.3123C22.8756 26.1548 22.9954 25.8223 22.8844 25.5278L22.1023 23.4389C22.5872 23.0347 23.0352 22.5867 23.4394 22.1018L25.5282 22.8839C25.824 22.995 26.1552 22.8739 26.3128 22.6013L27.057 21.3147C27.2146 21.0409 27.151 20.6925 26.9082 20.4923L25.1826 19.0719C25.3998 18.4863 25.5664 17.8775 25.6746 17.248L27.877 16.8822C28.1882 16.8292 28.4168 16.5604 28.4168 16.2439V14.7555C28.4168 14.4403 28.1882 14.1689 27.877 14.1172L25.6746 13.7514C25.5665 13.1227 25.3994 12.5149 25.1826 11.9299L26.9082 10.5071C27.1523 10.3069 27.2146 9.95849 27.057 9.68465L26.3128 8.39803C26.1552 8.1242 25.8227 8.0044 25.5282 8.11548L23.4394 8.89754C23.0352 8.41261 22.5872 7.9646 22.1023 7.56047L22.8844 5.4716C22.9954 5.17581 22.8743 4.8446 22.6018 4.68701L21.3152 3.94279C21.0414 3.78521 20.693 3.8488 20.4928 4.09163L19.0724 5.81722C18.4868 5.60004 17.878 5.43349 17.2485 5.32528L16.8826 3.12288C16.8297 2.81159 16.5608 2.58301 16.2444 2.58301H14.7559ZM14.2085 7.86572V11.8669C12.7136 12.406 11.6252 13.8293 11.6252 15.4997C11.6252 15.7411 11.6526 15.9763 11.6958 16.2061L8.23958 18.2016C7.92819 17.3601 7.75016 16.4525 7.75016 15.4997C7.75016 11.6455 10.5342 8.47791 14.2085 7.86572ZM16.7918 7.86572C20.4662 8.47791 23.2502 11.6455 23.2502 15.4997C23.2502 16.4528 23.0698 17.3598 22.7582 18.2016L19.3045 16.2061C19.3477 15.9763 19.3752 15.7411 19.3752 15.4997C19.3752 13.8293 18.2867 12.406 16.7918 11.8669V7.86572ZM15.5002 14.208C16.2288 14.208 16.7918 14.771 16.7918 15.4997C16.7918 16.2283 16.2288 16.7913 15.5002 16.7913C14.7715 16.7913 14.2085 16.2283 14.2085 15.4997C14.2085 14.771 14.7715 14.208 15.5002 14.208ZM13.0051 18.4312C13.683 19.01 14.5482 19.3747 15.5002 19.3747C16.4521 19.3747 17.3173 19.01 17.9952 18.4312L21.4792 20.4418C20.0602 22.1595 17.9138 23.2497 15.5002 23.2497C13.0865 23.2497 10.9401 22.1595 9.52116 20.4418L13.0051 18.4312Z"
              fill="black"
            />
          </svg>
        </Button>
      </div>
    </div>
  );
};

const AddSection = memo(
  ({ index, setSelectionType, setAddIndex, isAdding, clearRightPanel }) => {
    const handleClick = () => {
      if (isAdding) return;
      clearRightPanel();
      setSelectionType(MODULE_TYPES.ADD);
      setAddIndex(index);
    };
    return <SectionAdd disabled={isAdding} onAdd={handleClick} />;
  }
);

const Div = (props) => <div {...props} />;

export const PlaceHolderComponents = {
  // Videos
  [MODULE_TYPES.VIDEO_CONTINUE_WATCHING_CAROUSEL]: {
    title: 'Video Continue Watching Carousel',
    Component: VideoCarousel
  },
  [MODULE_TYPES.VIDEO_WATCH_LATER_CAROUSEL]: {
    title: 'Video Watch Later Carousel',
    Component: VideoCarousel
  },
  [MODULE_TYPES.VIDEO_CAROUSEL]: {
    title: 'Video Carousel',
    Component: VideoCarousel
  },
  [MODULE_TYPES.VIDEO_LIST]: { title: 'Video List', Component: VideoList },
  [MODULE_TYPES.VIDEO_GRID]: { title: 'Video Grid', Component: VideoGrid },
  [MODULE_TYPES.FEATURED_VIDEO]: {
    title: 'Featured Video',
    Component: FeaturedCarousel
  },
  [MODULE_TYPES.FEATURED_VIDEO_SLIDER]: {
    title: 'Featured Video Slider',
    Component: FeaturedCarousel
  },
  [MODULE_TYPES.VIDEO_PLAYER]: { title: 'Video Player', Component: VideoInfo },
  [MODULE_TYPES.VIDEO_PLAYER_V2]: {
    title: 'Video Player V2',
    Component: VideoInfoV2
  },
  // Collections
  [MODULE_TYPES.COLLECTION_CAROUSEL]: {
    title: 'Collection Carousel',
    Component: CollectionCarousel
  },
  [MODULE_TYPES.COLLECTION_GRID]: {
    title: 'Collection Grid',
    Component: CollectionGrid
  },
  [MODULE_TYPES.COLLECTION_LIST]: {
    title: 'Collection List',
    Component: CollectionList
  },
  [MODULE_TYPES.FEATURED_COLLECTION]: {
    title: 'Featured Collection',
    Component: FeaturedCollection
  },
  [MODULE_TYPES.FEATURED_COLLECTION_SLIDER]: {
    title: 'Featured Collection Slider',
    Component: FeaturedCollectionCarousel
  },
  [MODULE_TYPES.COLLECTION_ITEM_CAROUSEL]: {
    title: 'Collection Item Carousel'
  },
  [MODULE_TYPES.COLLECTION_ITEM_GRID]: {
    title: 'Collection Item Grid'
  },
  [MODULE_TYPES.COLLECTION_ITEM_LIST]: {
    title: 'Collection Item List'
  },
  // Contributors
  [MODULE_TYPES.CONTRIBUTOR_CAROUSEL]: {
    title: 'Contributor Carousel',
    Component: ContributorCarousel
  },
  [MODULE_TYPES.CONTRIBUTOR_GRID]: {
    title: 'Contributor Grid',
    Component: ContributorGrid
  },
  [MODULE_TYPES.CONTRIBUTOR_LIST]: {
    title: 'Contributor List',
    Component: ContributorList
  },
  [MODULE_TYPES.FEATURED_CONTRIBUTOR]: {
    title: 'Featured Contributor',
    Component: FeaturedContributor
  },
  // Tags
  [MODULE_TYPES.TAG_CAROUSEL]: {
    title: 'Tag Carousel',
    Component: TagCarousel
  },
  [MODULE_TYPES.TAG_CLOUD]: { title: 'Tag Cloud', Component: TagGrid },
  [MODULE_TYPES.FEATURED_TAG]: { title: 'Featured Tag', Component: TagHero },
  // Topics
  [MODULE_TYPES.TOPIC_CAROUSEL]: {
    title: 'Topic Carousel',
    Component: TopicCarousel
  },
  [MODULE_TYPES.TOPIC_LIST]: { title: 'Topic List', Component: TopicList },
  [MODULE_TYPES.TOPIC_GRID]: { title: 'Topic Grid', Component: TopicGrid },
  [MODULE_TYPES.FEATURED_TOPIC]: {
    title: 'Featured Topic',
    Component: CategoryCard
  },
  // CTA
  [MODULE_TYPES.CTA_BLOCK]: { title: 'CTA Block', Component: CtaCard },
  [MODULE_TYPES.CTA_GRID]: { title: 'CTA Grid', Component: CtaGrid },
  [MODULE_TYPES.CTA_CAROUSEL]: {
    title: 'CTA Carousel',
    Component: CtaCarousel
  },
  [MODULE_TYPES.CTA_BUTTON_LIST]: {
    title: 'CTA Button list',
    Component: CtaButtonList
  },
  [MODULE_TYPES.CTA_BANNER_WITH_TEXT]: {
    title: 'CTA Banner With Text',
    Component: CtaBanner
  },
  [MODULE_TYPES.CTA_BANNER]: { title: 'CTA Banner', Component: BannerImage },
  [MODULE_TYPES.HERO]: { title: 'Hero', Component: HeroBlock },
  // Article
  [MODULE_TYPES.ARTICLE_LIST]: {
    title: 'Article List',
    Component: ArticleList
  },
  [MODULE_TYPES.ARTICLE_LIST_V2]: {
    title: 'Article List V2',
    Component: ArticleListV2
  },
  [MODULE_TYPES.ARTICLE_CAROUSEL]: {
    title: 'Article Carousel',
    Component: ArticleCarousel
  },
  [MODULE_TYPES.ARTICLE_CAROUSEL_V2]: {
    title: 'Article Carousel V2',
    Component: ArticleCarouselV2
  },
  [MODULE_TYPES.FEATURED_ARTICLE]: {
    title: 'Featured Article',
    Component: FeatureArticleCard
  },
  [MODULE_TYPES.FEATURED_ARTICLE_V2]: {
    title: 'Featured Article V2',
    Component: FeaturedArticleCardV2
  },

  // Donation
  [MODULE_TYPES.DONATION]: { title: 'Donation', Component: Donate },
  // Copy Heavy
  [MODULE_TYPES.COPY_HEAVY]: { title: 'Copy Heavy', Component: HeavyModule },
  [MODULE_TYPES.COPY_HEAVY_HERO]: {
    title: 'Copy Heavy Hero',
    Component: HeavyModule
  },
  // Quote
  [MODULE_TYPES.QUOTE]: { title: 'Quote', Component: QuoteSlider },
  // Information
  [MODULE_TYPES.INFORMATION]: {
    title: 'Information',
    Component: InformationBlock
  },
  // Lead Gen
  [MODULE_TYPES.LEAD_GEN]: { title: 'Lead Gen', Component: NewsLetter },
  // Contact Us
  [MODULE_TYPES.CONTACT_US]: { title: 'Contact Us', Component: Contact },
  // FAQs
  [MODULE_TYPES.FAQ]: { title: 'FAQ', Component: FaqModule },
  // Spacer
  [MODULE_TYPES.SPACER]: { title: 'Spacer', Component: Div },
  // Podcast
  [MODULE_TYPES.PODCAST_CONTINUE_LISTENING_CAROUSEL]: {
    title: 'Podcast Continue Listening Carousel',
    Component: PodcastCarousel
  },
  [MODULE_TYPES.PODCAST_LISTEN_LATER_CAROUSEL]: {
    title: 'Podcast Listen Later Carousel',
    Component: PodcastCarousel
  },
  [MODULE_TYPES.PODCAST_CAROUSEL]: {
    title: 'Podcast Carousel',
    Component: PodcastCarousel
  },
  [MODULE_TYPES.PODCAST_LIST]: {
    title: 'Podcast List',
    Component: PodcastList
  },
  [MODULE_TYPES.PODCAST_GRID]: {
    title: 'Podcast Grid',
    Component: PodcastGrid
  },
  [MODULE_TYPES.FEATURED_PODCAST]: {
    title: 'Featured Podcast',
    Component: FeaturedPodcastCarousel
  },
  [MODULE_TYPES.FEATURED_PODCAST_SLIDER]: {
    title: 'Featured Podcast Slider',
    Component: FeaturedPodcastCarousel
  },
  [MODULE_TYPES.PODCAST_PLAYER]: {
    title: 'Podcast Player',
    Component: PodcastInfo
  },
  // Form
  [MODULE_TYPES.FORM_CAROUSEL]: {
    title: 'Form Carousel',
    Component: FormCarousel
  },
  [MODULE_TYPES.FORM_DISPLAY]: {
    title: 'Form Display',
    Component: FormDisplay
  },
  [MODULE_TYPES.SOURCE_CAROUSEL]: {
    title: 'Source Carousel'
  },
  [MODULE_TYPES.SOURCE_LIST]: {
    title: 'Source List'
  },
  [MODULE_TYPES.COMMUNITY_CAROUSEL]: {
    title: 'Community Carousel'
  },
  [MODULE_TYPES.COMMUNITY_GRID]: {
    title: 'Community Grid'
  },
  [MODULE_TYPES.FEATURED_COMMUNITY]: {
    title: 'Featured Community'
  },
  [MODULE_TYPES.FEATURED_COMMUNITY]: {
    title: 'Featured Community'
  },
  [MODULE_TYPES.POST_CAROUSEL]: {
    title: 'Post Carousel'
  },
  [MODULE_TYPES.POST_LIST]: {
    title: 'Post List'
  },
  [MODULE_TYPES.POST_DETAIL]: {
    title: 'Post Detail'
  }
};

const Module = memo(
  ({
    data,
    index,
    lastIndex,
    deletePageModule,
    deleteModule,
    moveModule,
    setForm,
    setSelectionType,
    isAdding,
    isEditing,
    isMoving,
    refetch,
    active
  }) => {
    const [isDeleting, setIsDeleting] = useState(false);

    const handleMoveUp = () => {
      if (isAdding || isEditing) return;
      moveModule(index, Math.max(0, index - 1));
    };

    const handleMoveDown = () => {
      if (isAdding || isEditing) return;
      moveModule(index, Math.min(lastIndex, index + 1));
    };

    const handleMoveTop = () => {
      if (isAdding || isEditing) return;
      moveModule(index, 0);
    };

    const handleMoveBottom = () => {
      if (isAdding || isEditing) return;
      moveModule(index, lastIndex);
    };

    const handleDelete = () => {
      if (isAdding || isEditing || !data.moduleData || isDeleting) return;

      modalContext?.confirm({
        title: 'Are you sure, you want to delete this page module?',
        centered: true,
        okText: 'Yes',
        cancelText: 'No',
        okType: 'primary',
        onOk() {
          setIsDeleting(true);
          deletePageModule({ variables: { id: data.moduleData.id } })
            .then(() => {
              deleteModule(index);
              setIsDeleting(false);
              refetch();
            })
            .catch(() => {
              setIsDeleting(false);
            });
        }
      });
    };

    const handleEdit = () => {
      if (isAdding) {
        return;
      }
      if (!data.moduleData) return;
      const { type } = data.moduleData;
      setForm({
        index,
        type: FORM_TYPES.EDIT,
        moduleId: data.moduleData?.id,
        defaultValues: cloneDeep(data.moduleData)
      });
      setSelectionType(type);
    };

    return (
      <SectionWrapper
        isFirst={index === 0}
        isLast={index === lastIndex}
        onMoveTop={handleMoveTop}
        onMoveUp={handleMoveUp}
        onMoveDown={handleMoveDown}
        onMoveBottom={handleMoveBottom}
        disableSort={isAdding || isEditing || isMoving}
      >
        <ModuleCard
          type={PlaceHolderComponents?.[data?.type]?.title}
          title={data?.moduleData?.title}
          active={active}
          onClick={handleEdit}
          disabled={isAdding}
          showDelete={data.moduleData?.id}
          disableDelete={isAdding || isEditing || isDeleting}
          loadingDelete={isDeleting}
          onDelete={handleDelete}
        />
      </SectionWrapper>
    );
  }
);

const LeftPanel = () => {
  const {
    modules,
    fetchingPageDetails,
    deletePageModule,
    deleteModule,
    moveModule,
    setForm,
    setSelectionType,
    isAdding,
    isEditing,
    isMoving,
    setAddIndex,
    clearRightPanel,
    form
  } = useEditPage();

  const { refetch } = usePagePreview();
  const lastIndex = modules.length - 1;

  const moduleProps = useMemo(
    () => ({
      deletePageModule,
      deleteModule,
      moveModule,
      setForm,
      setSelectionType,
      isAdding,
      isEditing,
      isMoving,
      refetch
    }),
    [isAdding, isEditing, isMoving, moveModule]
  );

  const addSectionProps = useMemo(
    () => ({
      setSelectionType,
      setAddIndex,
      isAdding,
      clearRightPanel
    }),
    [isAdding]
  );

  return (
    <TemplateLayout>
      <SettingButton />
      <>
        <AddSection index={0} {...addSectionProps} />
        {fetchingPageDetails ? (
          <Spin className="mt-12 ml-4" />
        ) : (
          <>
            {modules.map((module, index) => (
              <React.Fragment key={module.id}>
                <Module
                  data={module}
                  index={index}
                  lastIndex={lastIndex}
                  active={form?.index === index}
                  {...moduleProps}
                />
                <AddSection index={index + 1} {...addSectionProps} />
              </React.Fragment>
            ))}
          </>
        )}
      </>
    </TemplateLayout>
  );
};

export default LeftPanel;
